import React from 'react';
import { FacebookScript } from './scripts/FacebookScript';
import { OneTrustScript } from './scripts/OneTrustScript';
import { SegmentScript } from './scripts/SegmentScript';

export const GlobalScripts: React.FC = () => {
  return (
    <>
      <OneTrustScript />
      <FacebookScript />
      <SegmentScript />
    </>
  );
};
